module.exports = __webpack_public_path__ + "img/logo-pc.f5c9f6e6.png";